import orderCache from './order.vue'
export default orderCache



// WEBPACK FOOTER //
// ./pagesCache/order/index.js